"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLatestActivitySection = exports.AppLatestActivitySectionDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var section_1 = require("../elements/section");
var info_message_1 = require("../elements/info-message");
var use_lang_1 = require("../../hooks/use-lang");
var use_icons_1 = require("../../hooks/use-icons");
var platform_activity_entry_card_1 = require("../entities/platform-activity-entry-card");
var router_1 = require("@reach/router");
var badge_divider_1 = require("../elements/badge-divider");
exports.AppLatestActivitySectionDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(0))
});
var MessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " 1px;\n  "], ["\n    padding: ", " 1px;\n  "])), theme_1.theme.UNIT(2))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-left: 0;\n    margin-bottom: ", ";\n\n    ", " {\n      padding-left: ", ";\n    }\n  "], ["\n    padding-left: 0;\n    margin-bottom: ", ";\n\n    ", " {\n      padding-left: ", ";\n    }\n  "])), theme_1.theme.UNIT(4), platform_activity_entry_card_1.PlatformActivityEntryCard.cls.dot('person'), theme_1.theme.UNIT(4))
});
var MoreStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    cursor: pointer;\n    \n  "], ["\n    cursor: pointer;\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(section_1.Section)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  EmptyMessage: (0, styled_components_1.default)(info_message_1.InfoMessage)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), MessageStyles),
  Items: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: (0, styled_components_1.default)(platform_activity_entry_card_1.PlatformActivityEntryCard)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  More: (0, styled_components_1.default)(badge_divider_1.BadgeDivider)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), MoreStyles)
};
var AppLatestActivitySection = function (props) {
  var className = props.className,
    isDialog = props.isDialog,
    onItemClick = props.onItemClick,
    items = props.items;
  var t = (0, use_lang_1.useLang)();
  var Icons = (0, use_icons_1.useIcons)();
  if (items.length === 0) {
    return null;
  }
  return react_1.default.createElement(My.Container, {
    space: "v",
    icon: Icons.Entities.Feed,
    title: t('Latest Platform Activity'),
    className: className
  }, react_1.default.createElement(My.Items, null, items.map(function (item) {
    return react_1.default.createElement(My.Item, {
      key: item.id,
      entry: item
    });
  })), react_1.default.createElement(My.More, {
    lineVariant: 'dotted',
    onClick: function () {
      return (0, router_1.navigate)('/latest');
    }
  }, t('View All')));
};
exports.AppLatestActivitySection = AppLatestActivitySection;
exports.AppLatestActivitySection.defaultProps = exports.AppLatestActivitySectionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;